import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadContractEquipmentCategory {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdatePublicCompanyLeadContractEquipmentCategory = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContractEquipmentCategory) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatePublicCompanyLeadContractEquipmentCategory'],
    mutationFn: async (data: { id: string; quantity: string }) => {
      const lead = {
        contract_attributes: {
          contract_equipment_categories_attributes: data,
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
